import { jsx as _jsx } from "react/jsx-runtime";
import Typography from "../../../components/atoms/Typography/index.js";
export const SdbWithLoveAtomComponent = () => (_jsx(Typography, { "data-testid": "SdbWithCare", component: "span", sx: { color: ({ vars }) => vars.palette.surface.onVariant }, children: "Met zorg gemaakt door SDB" }));
export default SdbWithLoveAtomComponent;
